import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 md:py-24 px-4 md:px-8 bg-offwhite" data-id="element-134">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto text-center" data-id="element-135">
        <div className="w-16 h-16 md:w-20 md:h-20 bg-sage/10 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6" data-id="element-136">
          <ShieldCheck size={32} className="md:w-10 md:h-10 text-sage" data-id="element-137" />
        </div>

        <h2 className="font-serif text-3xl md:text-4xl font-bold text-brown mb-1 md:mb-2" data-id="element-138">
          7 DÍAS
        </h2>
        <h3 className="font-serif text-xl md:text-2xl font-bold text-sage mb-4 md:mb-6" data-id="element-139">
          GARANTÍA TOTAL
        </h3>

        <p className="font-sans text-lg md:text-xl text-brown/80 font-medium mb-4 md:mb-6" data-id="element-140">
          7 días para probarlo o les devolvemos el 100%
        </p>

        <p className="font-sans text-sm md:text-base text-brown/70 leading-relaxed max-w-2xl mx-auto" data-id="element-141">
          Abren los tomos, prueban el mapa de emociones, hacen la primera carta
          de conversación juntos. Si no es lo que esperaban: sin preguntas, sin
          formularios, sin drama.
        </p>
      </motion.div>
    </section>;
}